/* tslint:disable */
/* eslint-disable */
export enum WorkLedgerAccountTypeEnum {
  Asset = 'asset',
  Liability = 'liability',
  Equity = 'equity',
  Expense = 'expense',
  Revenue = 'revenue'
}
